'use strict';

var cov_odna8ferm = function () {
  var path = 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\routes.js',
      hash = '64e6dcc20f8bc8680976902a0483a31244cb3bcf',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 32,
          column: 24
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 81
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 74
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 19,
          column: 7
        }
      },
      '4': {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 7,
          column: 53
        }
      },
      '5': {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 11,
          column: 7
        }
      },
      '6': {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 9,
          column: 31
        }
      },
      '7': {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 30
        }
      },
      '8': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 18,
          column: 7
        }
      },
      '9': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 66
        }
      },
      '10': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 43
        }
      },
      '11': {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 63
        }
      },
      '12': {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 62
        }
      },
      '13': {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 52
        }
      },
      '14': {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 36
        }
      },
      '15': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 5
        }
      },
      '16': {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 155,
          column: 3
        }
      },
      '17': {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 57,
          column: 13
        }
      },
      '18': {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 31
        }
      },
      '19': {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 68,
          column: 13
        }
      },
      '20': {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 31
        }
      },
      '21': {
        start: {
          line: 85,
          column: 10
        },
        end: {
          line: 87,
          column: 13
        }
      },
      '22': {
        start: {
          line: 86,
          column: 12
        },
        end: {
          line: 86,
          column: 43
        }
      },
      '23': {
        start: {
          line: 96,
          column: 10
        },
        end: {
          line: 98,
          column: 13
        }
      },
      '24': {
        start: {
          line: 97,
          column: 12
        },
        end: {
          line: 97,
          column: 43
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 7
          },
          end: {
            line: 3,
            column: 8
          }
        },
        loc: {
          start: {
            line: 3,
            column: 109
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 48
          }
        },
        loc: {
          start: {
            line: 6,
            column: 53
          },
          end: {
            line: 19,
            column: 5
          }
        },
        line: 6
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 29,
            column: 35
          },
          end: {
            line: 29,
            column: 36
          }
        },
        loc: {
          start: {
            line: 29,
            column: 70
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 29
      },
      '3': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 35,
            column: 21
          }
        },
        loc: {
          start: {
            line: 35,
            column: 134
          },
          end: {
            line: 156,
            column: 1
          }
        },
        line: 35
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 54,
            column: 42
          },
          end: {
            line: 54,
            column: 43
          }
        },
        loc: {
          start: {
            line: 54,
            column: 71
          },
          end: {
            line: 58,
            column: 9
          }
        },
        line: 54
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 55,
            column: 74
          },
          end: {
            line: 55,
            column: 75
          }
        },
        loc: {
          start: {
            line: 55,
            column: 84
          },
          end: {
            line: 57,
            column: 11
          }
        },
        line: 55
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 65,
            column: 43
          },
          end: {
            line: 65,
            column: 44
          }
        },
        loc: {
          start: {
            line: 65,
            column: 72
          },
          end: {
            line: 69,
            column: 9
          }
        },
        line: 65
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 66,
            column: 75
          },
          end: {
            line: 66,
            column: 76
          }
        },
        loc: {
          start: {
            line: 66,
            column: 85
          },
          end: {
            line: 68,
            column: 11
          }
        },
        line: 66
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 84,
            column: 43
          },
          end: {
            line: 84,
            column: 44
          }
        },
        loc: {
          start: {
            line: 84,
            column: 72
          },
          end: {
            line: 88,
            column: 9
          }
        },
        line: 84
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 85,
            column: 75
          },
          end: {
            line: 85,
            column: 76
          }
        },
        loc: {
          start: {
            line: 85,
            column: 85
          },
          end: {
            line: 87,
            column: 11
          }
        },
        line: 85
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 95,
            column: 44
          },
          end: {
            line: 95,
            column: 45
          }
        },
        loc: {
          start: {
            line: 95,
            column: 73
          },
          end: {
            line: 99,
            column: 9
          }
        },
        line: 95
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 96,
            column: 76
          },
          end: {
            line: 96,
            column: 77
          }
        },
        loc: {
          start: {
            line: 96,
            column: 86
          },
          end: {
            line: 98,
            column: 11
          }
        },
        line: 96
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 11,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 11,
            column: 7
          }
        }, {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 11,
            column: 7
          }
        }],
        line: 8
      },
      '1': {
        loc: {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        }, {
          start: {
            line: 12,
            column: 6
          },
          end: {
            line: 18,
            column: 7
          }
        }],
        line: 12
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_odna8ferm.s[0];
angular.module('app').run(function (cfCryptoHttpInterceptor, $rootScope, $location, myVars, $http, localStorageService, $transitions) {
  ++cov_odna8ferm.f[0];
  ++cov_odna8ferm.s[1];

  $rootScope.base64Key = CryptoJS.enc.Base64.parse('51oc7lWGNg/W2Rs7CGUdCQ==');
  ++cov_odna8ferm.s[2];
  $rootScope.iv = CryptoJS.enc.Base64.parse('o/U1KF39hmtaui8/B+kP8w==');
  ++cov_odna8ferm.s[3];
  $transitions.onStart({ to: '*', from: '*' }, function () {
    ++cov_odna8ferm.f[1];

    var check = (++cov_odna8ferm.s[4], localStorageService.get('msisdn'));
    ++cov_odna8ferm.s[5];
    if (check != null) {
      ++cov_odna8ferm.b[0][0];
      ++cov_odna8ferm.s[6];

      myVars.checkMember = 0;
      ++cov_odna8ferm.s[7];
      myVars.msisdn = check;
    } else {
      ++cov_odna8ferm.b[0][1];
    }
    ++cov_odna8ferm.s[8];
    if (myVars.login !== 1) {
      // return $http.get(apiOpen).then(results => {
      //   myVars.msisdn = results.data.msisdn;
      //   myVars.checkMember = results.data.status;
      //   myVars.packageid = results.data.packageid;
      // });

      ++cov_odna8ferm.b[1][0];
    } else {
      ++cov_odna8ferm.b[1][1];
    }
  });

  // $rootScope.apiSec = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api/rest/secure/';
  // $rootScope.apiUrl = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api/';

  // $rootScope.apiOpen = 'http://localhost:5300/rest/open/';
  ++cov_odna8ferm.s[9];
  $rootScope.apiOpen = 'http://125.212.225.149:8300/rest/open/';
  //$rootScope.apiOpen = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api/rest/open/';
  // $rootScope.apiUrl = $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/api/';
}).run(['cfCryptoHttpInterceptor', function (cfCryptoHttpInterceptor) {
  ++cov_odna8ferm.f[2];
  ++cov_odna8ferm.s[10];

  cfCryptoHttpInterceptor.logging = true; // the default value is false. True will log the decrypted and the encrypted values to the console.
}]).config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, localStorageServiceProvider, $urlMatcherFactoryProvider) {
  ++cov_odna8ferm.f[3];
  ++cov_odna8ferm.s[11];

  localStorageServiceProvider.setStorageType('sessionStorage');
  ++cov_odna8ferm.s[12];
  localStorageServiceProvider.setStorageCookie(0, '/', false);
  ++cov_odna8ferm.s[13];
  $locationProvider.html5Mode(true).hashPrefix('!');
  ++cov_odna8ferm.s[14];
  $urlRouterProvider.otherwise('/');
  ++cov_odna8ferm.s[15];
  $urlMatcherFactoryProvider.type('SlashFix', {
    raw: true
  });

  ++cov_odna8ferm.s[16];
  $stateProvider.state('app', {
    url: '/?{DATA:SlashFix}&{SIG:SlashFix}',
    //url: '/',
    component: 'app'
  }).state('rule', {
    url: '/rule',
    component: 'rule',
    resolve: {
      ruleData: ['$rootScope', '$http', function ($rootScope, $http) {
        ++cov_odna8ferm.f[4];
        ++cov_odna8ferm.s[17];

        return $http.get($rootScope.apiOpen + 'content/find/rule').then(function (result) {
          ++cov_odna8ferm.f[5];
          ++cov_odna8ferm.s[18];

          return result.data;
        });
      }]
    }
  }).state('about', {
    url: '/about',
    component: 'about',
    resolve: {
      aboutData: ['$rootScope', '$http', function ($rootScope, $http) {
        ++cov_odna8ferm.f[6];
        ++cov_odna8ferm.s[19];

        return $http.get($rootScope.apiOpen + 'content/find/about').then(function (result) {
          ++cov_odna8ferm.f[7];
          ++cov_odna8ferm.s[20];

          return result.data;
        });
      }]
    }
  }).state('dstt', {
    url: '/danh-sach-trung-thuong',
    component: 'dstt'
  }).state('account', {
    url: '/tai-khoan',
    component: 'account'
  }).state('guide', {
    url: '/huong-dan',
    component: 'guide',
    resolve: {
      guideData: ['$rootScope', '$http', function ($rootScope, $http) {
        ++cov_odna8ferm.f[8];
        ++cov_odna8ferm.s[21];

        return $http.get($rootScope.apiOpen + 'content/find/guide').then(function (result) {
          ++cov_odna8ferm.f[9];
          ++cov_odna8ferm.s[22];

          return result.data.description;
        });
      }]
    }
  }).state('policy', {
    url: '/the-le',
    component: 'policy',
    resolve: {
      policyData: ['$rootScope', '$http', function ($rootScope, $http) {
        ++cov_odna8ferm.f[10];
        ++cov_odna8ferm.s[23];

        return $http.get($rootScope.apiOpen + 'content/find/policy').then(function (result) {
          ++cov_odna8ferm.f[11];
          ++cov_odna8ferm.s[24];

          return result.data.description;
        });
      }]
    }
  })
  // .state('clipgrid', {
  //   url: '/video',
  //   component: 'clipgrid',
  //   resolve: {
  //     videoData: ['$rootScope', '$http', function ($rootScope, $http) {
  //       return $http.get($rootScope.apiOpen + 'clips/getView').then(result => {
  //         return result.data;
  //       });
  //     }]
  //   }
  // })
  // .state('article', {
  //   url: '/tin-tuc/',
  //   component: 'article',
  //   resolve: {
  //     articleData: ['$rootScope', '$http', '$stateParams', 'myVars', function ($rootScope, $http, $stateParams) {
  //       return $http.get($rootScope.apiOpen + 'article/getFeatured').then(results => {
  //         return results.data;
  //       });
  //     }]
  //   }
  // })
  // .state('chitiet', {
  //   url: '/chi-tiet/:title/:articleid',
  //   component: 'arcview',
  //   resolve: {
  //     articleData: ['$rootScope', '$http', '$stateParams', 'myVars', function ($rootScope, $http, $stateParams) {
  //       return $http.get($rootScope.apiOpen + 'article/getDetail/' + $stateParams.articleid).then(results => {
  //         return results.data;
  //       });
  //     }]
  //   }
  // })
  // .state('views', {
  //   url: '/view/:title/:clipid',
  //   component: 'views',
  //   resolve: {
  //     clipData: ['$rootScope', '$http', '$stateParams', 'myVars', function ($rootScope, $http, $stateParams, myVars) {
  //       const content = {
  //         msisdn: myVars.msisdn,
  //         id: $stateParams.clipid
  //       };
  //       const config = {
  //         params: content,
  //         headers: {Accept: 'application/json'}
  //       };
  //       // return $http.get($rootScope.apiOpen + 'clips/find', config).then(results => {
  //       return $http.get($rootScope.apiOpen + 'clips/find/' + $stateParams.clipid).then(results => {
  //         return results.data;
  //       });
  //     }]
  //   }
  // })
  ;
}